import { Table } from "core/table/Table";
import { Typography } from "core/typography/Typography";
import { FormattedMessage } from "react-intl";
import {
  formattedData,
  formattedParams,
  headerToDisplay,
} from "utils/sharedDashboardHelper";
import { FILTERS_FOR_NAMES, QUERY_STATUS } from "constants/constants";
import ScrollToTop from "core/buttons/scroll-buttons/ScrollToTop";
import NoNesultIcon from "assets/icons/no-result.svg";
import { useContext, useEffect, useRef, useState } from "react";
import InfoContext from "pages/InfoContext";
import { useGeneralContext } from "api/directory/general/GeneralProvider";
import InfiniteScroll from "react-infinite-scroller";
import LoaderV2 from "core/loader/LoaderV2";
import Button from "core/buttons/button/Button";
import Icon from "core/icon/Icon";
import FloatingScrollbar from "core/floating-scrollbar/FloatingScrollbar";

const SharedDashboardByFilters = () => {
  const {
    userScope,
    section,
    onSubmit,
    lang,
    mutualDashboardICData,
    mutualDashboardFDMData,
    mutualDashboardEDData,
    mutualDashboardOKData,
    mutualDashboardCLData,
    mutualDashboardExitsData,
    infosBySection,
    companiesExitsCompaniesBy,
    getMutualDashboardCSVFile,
    loadExportStatus,
  } = useContext(InfoContext);
  const { namesByFilters, getNamesByFilters } = useGeneralContext() || {};

  const [
    updatedCompaniesExitsCompaniesBy,
    setUpdatedCompaniesExitsCompaniesBy,
  ] = useState();

  useEffect(() => {
    setUpdatedCompaniesExitsCompaniesBy(companiesExitsCompaniesBy);
  }, [mutualDashboardExitsData]);

  useEffect(() => {
    const rows = infosBySection[section]?.infos?.data;
    if (!rows?.length || !getNamesByFilters) return;
    const workerIds = [
      ...new Set(rows.map((r) => r.worker_id).filter(Boolean)),
    ];
    if (!workerIds.length) return;
    const knownIds = new Set(namesByFilters?.map((e) => e.id) || []);
    const missingIds = workerIds.filter((id) => !knownIds.has(id));
    if (missingIds.length) {
      getNamesByFilters({
        types: [FILTERS_FOR_NAMES.PERSON],
        id: missingIds,
      });
    }
  }, [infosBySection[section]?.infos?.data]);

  const tableContainerRef = useRef(null);

  const loadMoreResults = () => {
    if (infosBySection[section].loadDataStatus !== QUERY_STATUS.LOADING) {
      onSubmit({
        page: infosBySection[section].infos?.page + 1,
      });
    }
  };

  return (
    <div className="section">
      {infosBySection[section].infos.total > 0 && (
        <div
          className="display-flex"
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          <Typography
            className="title-3 violet text-uppercase"
            type="h2"
            label={
              <>
                <FormattedMessage id="results" defaultMessage="Résultats" />
                <span>: {infosBySection[section].infos.total}</span>{" "}
              </>
            }
          />
          <div className="results">
            <Button
              className="btn-outlined"
              size="medium"
              color="white"
              disabled={loadExportStatus === QUERY_STATUS.LOADING}
              onClick={() =>
                getMutualDashboardCSVFile({
                  lang,
                  section,
                  params: formattedParams({
                    filters: infosBySection[section].filters,
                    section,
                  }),
                })
              }
            >
              <Icon icon="sheet" color="green" height={20} marginRight={9} />
              <FormattedMessage
                id="export_excel"
                defaultMessage="Exporter en Excel"
              />
            </Button>
          </div>
        </div>
      )}
      <ScrollToTop />
      {infosBySection[section].infos.total === 0 &&
        infosBySection[section].loadDataStatus === QUERY_STATUS.SUCCESS && (
          <div className="no-result-wrapper">
            <img
              src={NoNesultIcon}
              alt="no-result-icon"
              className="no-result-icon"
            />
            <p className="title-4 violet no-result-text">
              <FormattedMessage
                id="no_results"
                defaultMessage="Oops, aucun résultat pour cette recherche."
              />
            </p>
          </div>
        )}
      {infosBySection[section].infos.total > 0 && (
        <>
          <div className="shared-dashboard-table-container" ref={tableContainerRef}>
            <InfiniteScroll
              pageStart={0}
              loadMore={loadMoreResults}
              hasMore={
                infosBySection[section].infos.data?.length <
                infosBySection[section].infos.total
              }
            >
              <Table
                id={`missions-by-filters`}
                header={headerToDisplay(
                  section,
                  updatedCompaniesExitsCompaniesBy
                )}
                content={
                  formattedData({
                    data: infosBySection[section].infos.data,
                    lang,
                    mutualDashboardICData,
                    mutualDashboardFDMData,
                    mutualDashboardEDData,
                    mutualDashboardOKData,
                    mutualDashboardCLData,
                    mutualDashboardExitsData,
                    userScope,
                    companiesExitsCompaniesBy,
                    namesByFilters,
                  }) || []
                }
                toolsManagerMission={false}
                userScope={userScope}
                alternRowColor={true}
              />
            </InfiniteScroll>
          </div>
          <FloatingScrollbar targetRef={tableContainerRef} />
        </>
      )}
      {infosBySection[section].loadDataStatus === QUERY_STATUS.LOADING && (
        <LoaderV2 />
      )}
    </div>
  );
};

export default SharedDashboardByFilters;
